import { render, staticRenderFns } from "./PriceRules.vue?vue&type=template&id=a17ba988&scoped=true"
import script from "./PriceRules.vue?vue&type=script&lang=js"
export * from "./PriceRules.vue?vue&type=script&lang=js"
import style0 from "./PriceRules.vue?vue&type=style&index=0&id=a17ba988&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17ba988",
  null
  
)

export default component.exports